import React, { ReactNode } from 'react';

import { cn } from '@/util/ui';

type CardProps = {
  className?: string;
  children: ReactNode;
};

const Card = ({ children, className }: CardProps) => {
  return (
    <div
      className={cn(
        'tw-border tw-border-cfo-grey-500 tw-bg-white tw-rounded-[10px] tw-flex tw-flex-col',
        className
      )}
    >
      {children}
    </div>
  );
};

export default Card;
